import React from "react"

export const ComplianceLabelTooltip = ({course}) => {
  const labelData = course.labelData
  // console.log(labelData)
  // console.log(course)

  const humanizedTerminology = () => {
    switch(labelData.terminology)
    {
    case 'crs':
      return 'USGA CRD'
    case 'scorecentre':
      return 'Score Centre'
    }
  }

  const getIdentificationString = () => {
    switch(labelData.terminology)
    {
    case 'crs':
      return `${window.I18n.t('courses.bootstrap_course_table_data.usga_crd_id')}: ${course.sourceId}`
    case 'scorecentre':
      return `${window.I18n.t('courses.bootstrap_course_table_data.score_centre_id')}: ${course.sourceId}`
    case 'whsuk':
      return `${window.I18n.t('courses.bootstrap_course_table_data.whs_id')}: ${course.sourceId}`
    }
  }

  const getImportDate = () => {
    const date = new Date(course.createdAt)
    return `${window.I18n.t('courses.bootstrap_course_table_data.import_date')}: ${date.toUTCString()}`
  }

  const getLastChangedDate  = () => {
    const date = new Date(course.updatedAt)
    return `${window.I18n.t('courses.bootstrap_course_table_data.last_changed')}: ${date.toUTCString()}`
  }

  const getComplianceChecked = () => {
    return window.I18n.t('course.process_crs_warnings.compliance_checked')
  }

  const getMissingCourseWarning = () => {
    return labelData.missingCourse && 
      <p>• {window.I18n.t('course.process_crs_warnings.course_not_present_in', { name: humanizedTerminology()})}.</p>
  }

  return(
    <div className="courses-tooltip-container">
      {getIdentificationString()}
      <br/>
      {getImportDate()}
      <br/>
      <div className="add-margin-bottom-5">
        {getLastChangedDate()}
      </div>
      <br/>
        {getComplianceChecked()}
      <br/>
      {getMissingCourseWarning()}
    </div>
  )
}